var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFj = function SvgIconFj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.74v4.048L7.826 5.74zM6.261 12.002h3.526L6.26 7.306l-.522 3.652z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.262V0h-.002C5.372 0 0 5.374 0 12h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.566a12.06 12.06 0 0 0-4.506 4.506V12h3.13V4.696H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.525 7.736 6.262H6.261L12 12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M13.565 7.827v4.174c0 2.796 3.653 3.652 3.653 3.652s3.652-.856 3.652-3.652V7.827l-3.652-1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.87 7.826V6.261h-7.305v1.565h3.13v3.13h-3.13V12h3.13v3.492c.316.112.523.16.523.16s.206-.048.521-.16V12h3.13v-1.043h-3.13v-3.13z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconFj;